@for (toast of visibleToasts(); track toast?.id ?? toast) {
  <ngb-toast
    [autohide]="autohide()"
    [delay]="toast.delay || delays()[toast.type]"
    [ngClass]="getToastClasses(toast, $last)"
    (hidden)="handleRemove(toast)"
    (mouseenter)="autohide.set(false)"
    (mouseleave)="autohide.set(true)">
    @if (toast.icon || toast.type) {
      <div class="mbs-toast-icon pr-1 mr-2">
        <span [ngClass]="getIconClasses(toast)"></span>
      </div>
    }

    <div class="mbs-toast-content">
      <!-- header of toast -->
      @if (toast.header) {
        <header
          class="mbs-toast-header"
          [class.text-break]="toast.textBreak === TextBreak.header || toast.textBreak === TextBreak.both">
          <ng-container
            [ngTemplateOutlet]="isTemplate(toast.header) ? templateRef : defaultHeader"
            [ngTemplateOutletContext]="{ $implicit: toast, content: toast.header }" />
          <ng-template #defaultHeader>
            <span
              class="mbs-toast-title pb-1"
              [innerHTML]="toast.header"></span>
          </ng-template>
        </header>
      }

      <!-- body of toast -->
      <div
        class="mbs-toast-body"
        [class.text-break]="toast.textBreak === TextBreak.content || toast.textBreak === TextBreak.both"
        [style.width]="toast.needEllipsis ? '280px' : 'initial'">
        <ng-container
          [ngTemplateOutlet]="isTemplate(toast.content) ? templateRef : innerHTMLTemplate"
          [ngTemplateOutletContext]="{ $implicit: toast, content: toast.content }" />
      </div>

      <!-- footer of toast -->
      @if (toast.footer || toast.buttons?.length) {
        <footer class="mbs-toast-footer mt-1">
          @if (toast.buttons; as buttons) {
            <div class="form-row">
              @for (button of buttons; track button?.label ?? button) {
                <div class="col-auto">
                  <mbs-button
                    [isCtrl]="button.isCtrl || true"
                    [size]="MbsSize.inherit"
                    [type]="$any(button.type || 'primary')"
                    (click)="onButtonClick(button, toast)">
                    {{ button.label || 'Show more...' }}
                  </mbs-button>
                </div>
              }
            </div>
          } @else {
            <ng-container
              [ngTemplateOutlet]="isTemplate(toast.footer) ? templateRef : innerHTMLTemplate"
              [ngTemplateOutletContext]="{ $implicit: toast, content: toast.footer }" />
          }
        </footer>
      }
    </div>

    <div class="mbs-toast-close pl-1 ml-2">
      <mbs-button
        [customClasses]="'text-xxs'"
        [icon]="'ico ico-Close'"
        [isCtrl]="true"
        (click)="handleRemove(toast)">
      </mbs-button>
    </div>
  </ngb-toast>
}

<!-- Templates -->
<ng-template
  #innerHTMLTemplate
  let-content="content"
  let-toast>
  @if (toast.needEllipsis) {
    <mbs-text-ellipsis>
      <div [outerHTML]="content | safe: 'html'"></div>
    </mbs-text-ellipsis>
  } @else if (toast.needLimitedContainer) {
    <div class="mbs-toast-limited-container">
      <div class="mbs-toast-limited-container-inner">
        <div [outerHTML]="content | safe: 'html'"></div>
        <div class="mbs-toast-limited-container-blur"></div>
      </div>
    </div>
  } @else {
    <div [outerHTML]="content | safe: 'html'"></div>
  }
</ng-template>

<ng-template
  #templateRef
  let-content="content"
  let-toast>
  <ng-container
    [ngTemplateOutlet]="content"
    [ngTemplateOutletContext]="{ $implicit: toast }" />
</ng-template>
